import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ModalController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { LoaderService } from 'src/app/services/loader.service';
import { AuthenticationStore } from 'src/app/stores/authentication.store';
import { SellerStore } from 'src/app/stores/seller.store';

@Component({
  selector: 'app-become-company-seller',
  templateUrl: './become-company-seller.component.html',
  styleUrls: ['./become-company-seller.component.scss'],
})
export class BecomeCompanySellerComponent implements OnInit {
  seller_form: FormGroup;
  validation_errors: any;
  @Input() type: boolean = false;
  constructor(
    private FormBuilder: FormBuilder,
    private seller: SellerStore,
    private loaderService: LoaderService,
    private translate: TranslateService,
    private modalCtrl: ModalController,
    private auth: AuthenticationStore
  ) { }

  async submit() {
    this.loaderService.showLoading();
    try {
      var resp: any = await this.seller.sellerChange(this.seller_form.value);
      this.loaderService.presentToast(
        this.translate.instant('PLACEHOLDER_TEXT.APPROVE_MESSAGE'),
        'bottom',
        'success',
        5000
      );
      this.modalCtrl.dismiss(resp);
      this.loaderService.dismissLoading();
    } catch (error) {
      this.loaderService.presentToast(
        error.error.data
          ? error.error.data
          : this.translate.instant('RATE_ORDER.SOMETHING_WRONG'),
        'middle',
        'danger',
        5000
      );
      this.loaderService.dismissLoading();
      this.modalCtrl.dismiss();
    }
  }

  dismiss() {
    this.modalCtrl.dismiss();
  }

  ngOnInit() {
    this.getErrors();
    this.seller_form = this.FormBuilder.group({
      business_id: new FormControl(
        '',
        Validators.compose([Validators.required])
      ),
    });
  }
  getErrors() {
    this.validation_errors = {
      business_id: [
        { type: 'required', message: `INDIVIDUAL_SELLER.BUSSINESS_REQUIRED` },
      ],
    };
  }

  back() {
    this.modalCtrl.dismiss();
  }
}
